import React from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView, BaseText } from '@/components/base'
import { ChevronLeft } from '@/assets/icons'
import { AppIcons } from '@/components/AppIcons'
import { useTheme } from '@/hooks/useTheme'
import useOffsets from '@/hooks/useOffsets'

interface HeaderNavigationProps {
  onBackPress?: () => void
  showBackButton?: boolean
  title?: string
  rightIcon?: React.ReactNode
  onMoreOptionsPress?: () => void
  marginHorizontal?: number
  /** Использовать fixed позиционирование */
  isFixed?: boolean
  /** Показывать ли фон при fixed позиционировании */
  showBackground?: boolean
  /** Дополнительные стили для контейнера */
  containerStyle?: React.CSSProperties
  /** Дочерние элементы для отображения под навигацией */
  children?: React.ReactNode
}

export const HeaderNavigation: React.FC<HeaderNavigationProps> = ({
  onBackPress,
  showBackButton = true,
  title,
  rightIcon,
  onMoreOptionsPress,
  marginHorizontal = 0,
  isFixed = false,
  showBackground = true,
  containerStyle = {},
  children,
}) => {
  const navigate = useNavigate()
  const theme = useTheme()
  const offsets = useOffsets()

  const handleBackPress = () => {
    if (onBackPress) {
      onBackPress()
    } else {
      navigate(-1)
    }
  }

  // Если используется fixed позиционирование, оборачиваем в контейнер
  if (isFixed) {
    const fixedStyle: React.CSSProperties = {
      position: 'fixed',
      width: '100%',
      top: 0,
      paddingTop: offsets.top,
      zIndex: 100,
      ...(showBackground && { backgroundColor: '#131415' }),
      ...containerStyle,
    }

    return (
      <div data-component="fixed-header-navigation" style={fixedStyle}>
        <BaseView
          row
          align="center"
          py={12}
          position="relative"
          style={{
            marginLeft: `${marginHorizontal}px`,
            marginRight: `${marginHorizontal}px`,
            minHeight: '56px',
          }}
        >
          {showBackButton && (
            <button
              onClick={handleBackPress}
              style={{
                padding: '4px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                zIndex: 10,
              }}
            >
              <ChevronLeft size={28} color={theme.colors.label.default} />
            </button>
          )}

          {title && (
            <BaseView
              flex={1}
              center
              justify="center"
              style={{
                position: 'absolute',
                left: '0px',
                right: '0px',
                top: '50%',
                transform: 'translateY(-50%)',
                paddingLeft: showBackButton ? '56px' : '0px',
                paddingRight: showBackButton
                  ? '56px'
                  : rightIcon || onMoreOptionsPress
                    ? '56px'
                    : '0px',
                zIndex: 1,
              }}
            >
              <BaseText
                fontSize={20}
                fontFamily="semibold"
                color="label.default"
              >
                {title}
              </BaseText>
            </BaseView>
          )}

          {onMoreOptionsPress && (
            <button
              onClick={onMoreOptionsPress}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                padding: '4px',
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <AppIcons
                name="ellipses"
                size={28}
                color={theme.colors.label.default}
              />
            </button>
          )}

          {rightIcon && !onMoreOptionsPress && rightIcon}
        </BaseView>

        {/* Дочерние элементы */}
        {children && (
          <BaseView
            style={{
              paddingLeft: `${marginHorizontal}px`,
              paddingRight: `${marginHorizontal}px`,
              paddingBottom: '12px',
            }}
          >
            {children}
          </BaseView>
        )}
      </div>
    )
  }

  return (
    <BaseView pt={12}>
      <BaseView
        row
        align="center"
        // py={12}
        justify="space-between"
        position="relative"
        style={{
          marginLeft: `${marginHorizontal}px`,
          marginRight: `${marginHorizontal}px`,
          // minHeight: '56px',
        }}
      >
        {showBackButton && (
          <button
            onClick={handleBackPress}
            style={{
              padding: '4px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              zIndex: 10,
            }}
          >
            <ChevronLeft size={28} color={theme.colors.label.default} />
          </button>
        )}

        {title && (
          <BaseView
            flex={1}
            center
            justify="center"
            style={{
              position: 'absolute',
              left: '0px',
              right: '0px',
              top: '50%',
              transform: 'translateY(-50%)',
              paddingLeft: showBackButton ? '56px' : '0px',
              paddingRight: showBackButton
                ? '56px'
                : rightIcon || onMoreOptionsPress
                  ? '56px'
                  : '0px',
              zIndex: 1,
            }}
          >
            <BaseText fontSize={20} fontFamily="semibold" color="label.default">
              {title}
            </BaseText>
          </BaseView>
        )}

        {onMoreOptionsPress && (
          <button
            onClick={onMoreOptionsPress}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              zIndex: 10,
              padding: '4px',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AppIcons
              name="ellipses"
              size={28}
              color={theme.colors.label.default}
            />
          </button>
        )}

        {rightIcon && !onMoreOptionsPress && rightIcon}
      </BaseView>

      {/* Дочерние элементы */}
      {children && (
        <BaseView
          style={{
            paddingLeft: `${marginHorizontal}px`,
            paddingRight: `${marginHorizontal}px`,
            paddingBottom: '12px',
          }}
        >
          {children}
        </BaseView>
      )}
    </BaseView>
  )
}
